import { useCallback, useRef } from "react";

export const useDebouncedReload = <T>(
    callback: (arg: T) => void,
    delay = 500
) => {
    const debounceTimer = useRef<Map<T, ReturnType<typeof setTimeout>>>(
        new Map()
    );

    const debouncedCall = useCallback(
        (arg: T) => {
            if (debounceTimer.current.has(arg)) {
                clearTimeout(debounceTimer.current.get(arg));
            }

            const timer = setTimeout(() => {
                callback(arg);
                debounceTimer.current.delete(arg);
            }, delay);

            debounceTimer.current.set(arg, timer);
        },
        [callback, delay]
    );

    return debouncedCall;
};
